export default __webpack_public_path__ + "static/media/2020-peisaj-1.d8e862c7.jpeg";